import React, { useState } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Copy, Eye, EyeOff, Lock, User2 } from "lucide-react";
import { toast } from "react-hot-toast";
import { RiDeleteBin6Fill } from "react-icons/ri";


interface UserCardProps {
	username: string;
	plainTextPassword: string | null;
	onClick?: () => void;
}

const CredCard: React.FC<UserCardProps> = ({ username, plainTextPassword, onClick }) => {
	const [showPassword, setShowPassword] = useState(false);

	const handleCopy = (text: string) => {
		navigator.clipboard.writeText(text);
		toast.success("Copied to clipboard!");
	};

	return (
		<Card className="border border-gray-200 shadow-sm">
			<CardHeader className="flex flex-row items-center justify-between pb-2"></CardHeader>
			<CardContent>
				<div className="flex items-center justify-between ">
					<div className="text-sm font-medium flex items-center gap-5">
						<User2 className="h-4 w-4" /> <span>username:</span>
						<span> {username || "N/A"}</span>
						<button className="flex items-center space-x-1 text-gray-500 hover:text-gray-700" onClick={() => handleCopy(username)}>
							<Copy className="h-4 w-4" />
							<span className="text-xs">Copy</span>
						</button>
					</div>
					<div className="text-sm font-medium flex items-center  gap-5">
						<Lock className="h-4 w-4" /> <span>Password:</span>
						<span>{showPassword ? plainTextPassword || "N/A" : "••••••••"}</span>
						{plainTextPassword && (
							<button className="text-gray-500 hover:text-gray-700" onClick={() => setShowPassword(!showPassword)}>
								{showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
							</button>
						)}
						{plainTextPassword && (
							<button className="flex items-center space-x-1 text-gray-500 hover:text-gray-700" onClick={() => handleCopy(plainTextPassword)}>
								<Copy className="h-4 w-4" />
								<span className="text-xs">Copy</span>
							</button>
						)}
						{onClick && (
							<RiDeleteBin6Fill className="h-4 w-4 text-red-500" onClick={onClick} />
						)}
					</div>
				</div>
				{/* <p className="text-xs text-muted-foreground mt-1">+2% from last month</p> */}
			</CardContent>
		</Card>
	);
};

export default CredCard;
